import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=82622f3e"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"
import style0 from "./not-found.vue?vue&type=style&index=0&id=82622f3e&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82622f3e')) {
      api.createRecord('82622f3e', component.options)
    } else {
      api.reload('82622f3e', component.options)
    }
    module.hot.accept("./not-found.vue?vue&type=template&id=82622f3e", function () {
      api.rerender('82622f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/not-found/not-found.vue"
export default component.exports